import {createRouter, createWebHistory} from "vue-router";
import Home from "../views/home/Home.vue";
import nProgress from "nprogress";
import 'nprogress/nprogress.css'

import {getTypeList} from '@/utils/methodUtil';
import WorkPhoneManage from "@/views/workPhone/WorkPhoneManage";
import Menus from "@/views/manage/Menus";
import WorkPhoneCost from "@/views/workPhone/WorkPhoneCost";
import CardRole from "@/views/card/CardRole";
import CourseTypeManage from "@/views/courseRecord/CourseTypeManage";
import Drainage from "../views/statistical/Drainage";
import Attendance from "../views/courseRecord/Attendance";
import AreaRate from "../views/coach/AreaRate";

const routes = [
        {
            path: '/',
            // redirect: url
            redirect: '/homeDetail'
        },
        {
            path: "/",
            name: "homeDetail",
            component: Home,
            redirect: '/homeDetail',
            children: [
                {
                    path: "/homeDetail",
                    name: "首页",
                    meta: {
                        title: '首页'
                    },
                    component: () => import ("../views/home/HomeDetail.vue")
                },
                {
                    path: "/coach",
                    name: "教练管理",
                    meta: {
                        title: '教练管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/coach/Coach")
                },
                {
                    path: "/mentorRelation",
                    name: "师徒关系管理",
                    meta: { title: '师徒关系管理' },
                    component: () => import ("../views/mentor/MentorRelationManage")
                },
                {
                    path: "/mentorTask",
                    name: "师徒任务管理",
                    meta: { title: '师徒任务管理' },
                    component: () => import ("../views/mentor/MentorTaskManage")
                },
                {
                    path: "/mentorRadar",
                    name: "师徒雷达报告",
                    meta: { title: '师徒雷达报告' },
                    component: () => import ("../views/mentor/MentorRadarView")
                },
                {
                    path: "/user",
                    name: "用户游客管理",
                    meta: {
                        title: '用户管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/coach/User")
                },
                {
                    path: "/students",
                    name: "学生管理",
                    meta: {
                        title: '学生管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/student/studentList")
                },
                {
                    path: "/orders",
                    name: "订单统计",
                    meta: {
                        title: '订单统计',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/statistical/Orders")
                },
                {
                    path: "/courses",
                    name: "课时统计",
                    meta: {
                        title: '课时统计',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/statistical/Courses")
                },
                {
                    path: "/coursesRecord",
                    name: "课时记录",
                    meta: {
                        title: '课时记录',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/courseRecord/CoursesRecord")
                },
                {
                    path: "/coursesEvaluate",
                    name: "课时评价",
                    meta: {
                        title: '课时评价',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/courseRecord/CoursesEvaluate")
                },
                {
                    path: "/CourseConfirm",
                    name: "课时确认",
                    meta: {
                        title: '课时确认',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/courseRecord/CourseConfirm")
                },
                {
                    path: "/PerformanceConfirm",
                    name: "业绩确认",
                    meta: {
                        title: '业绩确认',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/order/PerformanceConfirm")
                },
                {
                    path: "/userReturn",
                    name: "家长申请退费",
                    meta: {
                        title: '家长申请退费',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/order/return/UserReturn")
                },
                {
                    path: "/courseScheduling",
                    name: "排课记录列表",
                    meta: {
                        title: '排课记录列表',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/courseRecord/CourseScheduling")
                },
                {
                    path: "/testTree",
                    name: "测试页面",
                    meta: {
                        title: 'testTree',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/thread/TestTree")
                },
                {
                    path: "/campus",
                    name: "校区管理",
                    meta: {
                        title: '校区管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/Campus")
                },
                {
                    path: "/banner",
                    name: "轮播图管理",
                    meta: {
                        title: '轮播图管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/Banner"),
                },
                {
                    path: "/trainingRecord",
                    name: "教学培训",
                    meta: {
                        title: '教学培训',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/TrainingRecord"),
                },
                {
                    path: "/region",
                    name: "区域城市管理",
                    meta: {
                        title: '区域城市管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/Region"),
                },
                {
                    path: "/card",
                    name: "(老)卡片管理",
                    meta: {
                        title: '卡片管理',
                        keepAlive: true
                    },
                    component: () => import ("../views/manage/CardType")
                },
                {
                    path: "/card2",
                    name: "卡片管理",
                    meta: {
                        title: '卡片管理'
                    },
                    component: () => import ("../views/card/Card")
                },
                {
                    path: "/cardRole",
                    name: "卡片角色",
                    meta: {
                        title: '卡片角色'
                    },
                    component: CardRole
                },
                {
                    path: "/courseType",
                    name: "消课类型",
                    meta: {
                        title: '消课类型'
                    },
                    component: CourseTypeManage
                },
                {
                    path: "/calculator",
                    name: "中考计算器",
                    meta: {
                        title: '中考计算器'
                    }, component: () => import (
                        "../views/manage/Calculator")
                },
                {
                    path: "/competeEnterprise",
                    name: "竞品企业",
                    meta: {
                        title: '竞品企业'
                    }, component: () => import ("../views/manage/CompeteEnterprise")
                },
                {
                    path: "/OrdersManage",
                    name: "订单管理",
                    meta: {
                        title: '订单管理',
                        keepAlive: true
                    },
                    component: () => import ("../views/order/OrdersManage")
                },
                {
                    path: "/contract",
                    name: "合同管理",
                    meta: {
                        title: '合同管理',
                        keepAlive: true
                    },
                    component: () => import ("../views/order/Contract")
                },
                {
                    path: "/follow",
                    name: "回访管理",
                    meta: {
                        title: '回访管理',
                        keepAlive: true
                    },
                    component: () => import("../views/order/Follow")
                },
                {
                    path: "/tradingRecord",
                    name: "缴费记录",
                    meta: {
                        title: '缴费记录',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/order/TradingRecord")
                },
                {
                    path: "/qc",
                    name: "器材管理",
                    meta: {
                        title: '器材管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/Equipment")
                },
                {
                    path: "/qcLq",
                    name: "器材领取记录",
                    meta: {
                        title: '器材领取记录',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/EquipmentLq")
                },
                {
                    path: "/equipmentMovements",
                    name: "器材入库单",
                    meta: {
                        title: '器材入库单',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/EquipmentMovements")
                },
                {
                    path: "/menus",
                    name: "小程序菜单",
                    meta: {
                        title: '小程序菜单',
                        keepAlive: true
                    },
                    component:Menus
                },
                {
                    path: "/roles",
                    name: "角色管理",
                    meta: {
                        title: '角色管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/manage/Roles")
                },
                {
                    path: "/transcript",
                    name: "体测学员管理",
                    meta: {
                        title: '体测学员管理'
                    },
                    component: () => import (
                        "../views/transcript/Transcript")
                },
                {
                    path: "/sysUser",
                    name: "用户管理",
                    meta: {
                        title: '用户管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/system/SYSUser")
                },
                {
                    path: "/SYSMenu",
                    name: "菜单管理",
                    meta: {
                        title: '菜单管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/system/SYSMenu")
                },
                {
                    path: "/stopOrder",
                    name: "停卡明细",
                    meta: {
                        title: '停卡明细',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/order/SopOrder")
                },
                {
                    path: "/apportionOrder",
                    name: "订单分摊",
                    meta: {
                        title: '订单分摊'
                    },
                    component: () => import (
                        "../views/order/apportion/ApportionOrder")
                },
                {
                    path: "/financeApportionOrder",
                    name: "财务分摊",
                    meta: {
                        title: '财务分摊'
                    },
                    component: () => import (
                        "../views/order/FinanceApportionOrder")
                },
                {
                    path: "/citiesApportion",
                    name: "地市分摊",
                    meta: {
                        title: '地市分摊'
                    },
                    component: () => import (
                        "../views/order/apportion/CitiesApportion")
                },
                {
                    path: "/zhengzhouApportion",
                    name: "郑州分摊",
                    meta: {
                        title: '郑州分摊'
                    },
                    component: () => import (
                        "../views/order/apportion/ZhengzhouApportion")
                },
                {
                    path: '/bodyFinancial',
                    name: '少年分摊',
                    meta: {
                        title: '少年分摊'
                    },
                    component: () => import(
                        '../views/order/apportion/bodyFinancial'
                        )
                },
                {
                    path: "/area",
                    name: "区域管理",
                    meta: {
                        title: '区域管理',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/system/Area")
                },
                {
                    path: "/toJoinApply",
                    name: "加盟申请",
                    meta: {
                        title: '加盟申请',
                        keepAlive: true
                    },
                    component: () => import (
                        "../views/system/ToJoinApply")
                },
                {
                    path: "/unpaidOrder",
                    name: "微信支付-待支付",
                    meta: {
                        title: '微信支付'
                    },
                    component: () => import (
                        "../views/order/UnpaidOrder")
                },
                {
                    path: '/return',
                    name: '退费管理',
                    meta: {
                        title: '退费',
                        keepAlive: true
                    },
                    component: () => import(
                        "../views/order/return/Return"
                        )
                },
                {
                    path: '/turn',
                    name: '转卡管理',
                    meta: {
                        title: '转卡',
                        keepAlive: true
                    },
                    component: () => import(
                        "../views/order/turn/turn"
                        )
                },
                {
                    path: '/wangEditor',
                    name: '帮助中心',
                    meta: {
                        title: '帮助中心',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/system/Wangdditor'
                        )
                },
                {
                    path: '/courseSchedule',
                    name: '课程表',
                    meta: {
                        title: '课程表',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/courseSchedule/CourseSchedule'
                        )
                },
                {
                    path: '/dictionaries',
                    name: '字典',
                    meta: {
                        title: '字典',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/system/dictionaries'
                        )
                },
                {
                    path: '/framework',
                    name: '教练组织架构',
                    meta: {
                        title: '教练组织架构',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views//manage/Framework'
                        )
                },
                {
                    path: '/video',
                    name: '视频管理',
                    meta: {
                        title: '视频管理',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/video/Video'
                        )
                },
                {
                    path: '/wuhanApportion',
                    name: '武汉分摊',
                    meta: {
                        title: '武汉分摊'
                    },
                    component: () => import(
                        '../views/order/apportion/wuhanApportion'
                        )
                },
                {
                    path: '/homeDetail',
                    name: '首页',
                    meta: {
                        title: '首页'
                    },
                    component: () => import(
                        '../views/home/HomeDetail'
                        )
                },
                {
                    path: '/ceshi',
                    name: '组织架构-部门',
                    meta: {
                        title: '组织架构-部门'
                    },
                    component: () => import(
                        '../views/ceshi/ceshi1'
                        )
                },
                {
                    path: '/crmLine',
                    name: '线索列表',
                    meta: {
                        title: '线索列表'
                    },
                    component: () => import(
                        '../views/attract/CrmLine'
                        )
                },
                {
                    path: '/attract',
                    name: '客户管理',
                    meta: {
                        title: '客户管理'
                    },
                    component: () => import(
                        '../views/attract/attract'
                        )
                },
                {
                    path: '/workPhoneManage',
                    name: '号卡管理',
                    meta: {
                        title: '号卡管理'
                    },
                    component: WorkPhoneManage
                },
                {
                    path: '/workPhoneCost',
                    name: '号卡费用',
                    meta: {
                        title: '号卡费用'
                    },
                    component: WorkPhoneCost
                },
                {
                    path: '/attractContact',
                    name: '联系记录',
                    meta: {
                        title: '联系记录'
                    },
                    component: () => import(
                        '../views/attract/AttractContact'
                        )
                },
                {
                    path: '/attractOrder',
                    name: '签单记录',
                    meta: {
                        title: '签单记录'
                    },
                    component: () => import(
                        '../views/attract/AttractOrder'
                        )
                },
                {
                    path: '/attractLink',
                    name: '招商环节',
                    meta: {
                        title: '招商环节'
                    },
                    component: () => import(
                        '../views/attract/AttractLink'
                        )
                },
                {
                    path: '/groundPush',
                    name: '地推统计',
                    meta: {
                        title: '地推统计'
                    },
                    component: () => import(
                        '../views/statistical/Groundpush'
                        )
                },
                {
                    path: '/roster',
                    name: '花名册',
                    meta: {
                        title: '花名册'
                    },
                    component: () => import(
                        '../views/coach/roster/Roster'
                        )
                },
                {
                    path: '/questionnaire',
                    name: '日数据管理汇总',
                    meta: {
                        title: '日数据管理汇总'
                    },
                    component: () => import(
                        '../views/system/Questionnaire'
                        )
                },
                {
                    path: '/performanceTarget',
                    name: '业绩目标',
                    meta: {
                        title: '业绩目标'
                    },
                    component: () => import(
                        '../views/monthTarget/PerformanceTarget'
                        )
                },
                {
                    path: '/yearTotalTarget',
                    name: '年度总目标',
                    meta: {
                        title: '年度总目标'
                    },
                    component: () => import(
                        '../views/monthTarget/YearTotalTarget'
                        )
                },
                {
                    path: '/targetStatistics',
                    name: '业绩统计',
                    meta: {
                        title: '业绩统计'
                    },
                    component: () => import(
                        '../views/monthTarget/TargetStatistics'
                        )
                },
                {
                    path: '/overallLog',
                    name: '全局日志记录',
                    meta: {
                        title: '全局日志记录'
                    },
                    component: () => import(
                        '../views/log/OverallLog'
                        )
                },
                {
                    path: '/products',
                    name: '商品管理',
                    meta: {
                        title: '商品管理'
                    },
                    component: () => import(
                        '../views/mall/Products'
                        )
                },
                {
                    path: '/integralDetail',
                    name: '积分明细',
                    meta: {
                        title: '积分明细'
                    },
                    component: () => import(
                        '../views/mall/IntegralDetail'
                        )
                },
                {
                    path: '/prizeDetail',
                    name: '奖品明细',
                    meta: {
                        title: '奖品明细'
                    },
                    component: () => import(
                        '../views/mall/PrizeDetail'
                        )
                },
                {
                    path: '/gainIntegralRule',
                    name: '积分规则',
                    meta: {
                        title: '积分规则'
                    },
                    component: () => import(
                        '../views/mall/GainIntegralRule'
                        )
                },
                {
                    path: '/appManage',
                    name: 'App版本管理',
                    meta: {
                        title: 'App版本管理'
                    },
                    component: () => import(
                        '../views/manage/AppManage'
                        )
                },
                {
                    path: '/threadList',
                    name: '线索管理',
                    meta: {
                        title: '线索管理',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/thread/ThreadList'
                        )
                },
                {
                    path: '/newThreadList',
                    name: '新线索管理',
                    meta: {
                        title: '新线索管理',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/thread/NewThreadList'
                        )
                },
                {
                    path: '/courseTarget',
                    name: '课消目标',
                    meta: {
                        title: '课消目标',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/monthTarget/courseTarget'
                        )
                },
                {
                    path: '/probationList',
                    name: '试课列表',
                    meta: {
                        title: '试课列表',
                        keepAlive: true
                    },
                    component: () => import(
                        '../views/order/ProbationList'
                        )
                },
                {
                    path: '/physicalTest',
                    name: '焱火体测',
                    meta: {
                        title: '焱火体测',
                    },
                    component: () => import(
                        '../views/statistical/physicalTest'
                        )
                },
                {
                    path: '/free',
                    name: '零元卡',
                    meta: {
                        title: '零元卡',
                    },
                    component: () => import(
                        '../views/applyRecord/free/Free'
                        )
                },
                {
                    path: '/dingHistorical',
                    name: '钉钉历史数据',
                    meta: {
                        title: '钉钉历史数据',
                    },
                    component: () => import(
                        '../views/dingHistorical/DingHistorical'
                        )
                },
                {
                    path: '/pkGame',
                    name: 'PK管理',
                    meta: {
                        title: 'PK',
                    },
                    component: () => import(
                        '../views/pk/PKGame'
                        )
                },
                {
                    path: '/policyPhoto',
                    name: '政策、学员图片',
                    meta: {
                        title: '政策、学员图片',
                    },
                    component: () => import(
                        '../views/manage/policyPhoto'
                        )
                },
                {
                    path: '/submitOther',
                    name: '职能提报',
                    meta: {
                        title: '职能提报',
                    },
                    component: () => import(
                        '../views/order/SubmitOther'
                        )
                },
                {
                    path: '/activityList',
                    name: '活动列表',
                    meta: {
                        title: '活动列表'
                    },
                    component: () => import(
                        '../views/activity/activityList'
                        )
                },
                {
                    path: '/batchDisable',
                    name: '批量失效',
                    meta: {
                        title: '批量失效'
                    },
                    component: () => import(
                        '../views/order/batch/batchDisable'
                        )
                },
                {
                    path: '/batchTurn',
                    name: '批量转卡',
                    meta: {
                        title: '批量转卡'
                    },
                    component: () => import(
                        '../views/order/batch/batchTurn'
                        )
                },
                {
                    path: '/trainee',
                    name: '试课转化',
                    meta: {
                        title: '试课转化'
                    },
                    component: () => import(
                        '../views/statistical/Trainee'
                        )
                },
                {
                    path: '/coachNewbieTask',
                    name: '入职任务设置',
                    meta: {
                        title: '入职任务设置'
                    },
                    component: () => import(
                        '../views/coach/CoachNewbieTask'
                        )
                },
                {
                    path: '/coachNewbieTaskDetails',
                    name: '入职任务统计',
                    meta: {
                        title: '入职任务统计'
                    },
                    component: () => import(
                        '../views/coach/CoachNewbieTaskDetails'
                        )
                },
                {
                    path: '/a2',
                    name: '出勤1',
                    meta: {
                        title: '出勤1'
                    },
                    component: () => import(
                        '../views/courseRecord/Attendance'
                        )
                },
                {
                    path: '/enrolledAttendance',
                    name: '有价值在籍出勤',
                    meta: {
                        title: '有价值在籍出勤'
                    },
                    component: () => import(
                        '../views/courseRecord/EnrolledAttendance'
                        )
                },
                {
                    path: '/attendance',
                    name: '出勤2',
                    meta: {
                        title: '出勤2'
                    },component:Attendance

                },
                {
                    path: '/expirationReminder',
                    name: '出勤3',
                    meta: {
                        title: '出勤3'
                    },
                    component: () => import(
                        '../views/system/ExpirationReminder'
                        )
                },
                {
                    path: '/PrintPreView',
                    name: 'PrintPreView',
                    meta: {
                        title: '打印预览'
                    },
                    component: () => import(
                        '../views/coach/roster/components/PrintPreView'
                        )
                },
                {
                    path: '/honor',
                    name: '荣誉殿堂',
                    meta: {
                        title: '荣誉殿堂'
                    },
                    component: () => import(
                        '../views/coach/honor/Honor'
                        )
                },
                {
                    path: '/drainage',
                    name: '引流转化',
                    meta: {
                        title: '引流转化'
                    },
                    component: Drainage
                },
                {
                    path: '/merchant',
                    name: '商户管理',
                    meta: {
                        title: '商户管理'
                    },
                    component: () => import('../views/order/Merchant')
                },
                {
                    path: '/ReturnVisitRate',
                    name: '回访率',
                    meta: {
                        title: '回访率'
                    },
                    component: () => import('../views/order/ReturnVisitRate')
                },
                {
                    path: '/CoachClassFee',
                    name: '课时费管理',
                    meta: {
                        title: '课时费管理'
                    },
                    component: () => import('../views/coach/CoachClassFee')
                },
                {
                    path: '/CoachMonthFee',
                    name: '课时费统计',
                    meta: {
                        title: '课时费统计'
                    },
                    component: () => import('../views/coach/CoachMonthFee')
                },
                {
                    path:'/areaRate',
                    name:'校区效比',
                    meta:{title: '校区效比'},
                    component:AreaRate

                },
                {
                    path: '/cadastralStudent',
                    name: '在籍学员',
                    meta: {
                        title: '在籍学员'
                    },
                    component: () => import('../views/coach/CadastralStudent')
                },
                {
                    path: '/sonMerchant',
                    name: '商户详情',
                    meta: {
                        title: '商户详情'
                    },
                    component: () => import('../views/order/SonMerchant')
                },
            ]
        },
        {
            path: "/login",
            name: "Login",
            meta: {
                title: '登录'
            },
            component: () => import (
                "../views/NewLogin")
        }
    ]
;

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes:routes
});

/* 挂载路由导航守卫 */
router.beforeEach((to, from, next) => {
    // 每次实时读取 localStorage，避免模块级变量缓存旧值导致登录后跳转被拦回登录页
    let menu = null
    try {
        menu = JSON.parse(localStorage.getItem('menu'))
    } catch (e) {
        menu = null
    }
    if (menu) {
        getTypeList(menu, to.path)
    }
    document.title = `${to.meta.title || ''} | AA焱火体育`;
    const tokenStr = window.localStorage.getItem('token')
    const hasToken = tokenStr !== null && tokenStr !== 'undefined' && tokenStr !== ''

    // 登录页：未登录放行；已登录直接进入系统（避免卡在登录页）
    if (to.path === '/login') {
        if (hasToken && menu && menu.length > 0) {
            const first = menu[0]
            const target = first.children && first.children.length > 0 ? `/${first.children[0].index}` : `/${first.index}`
            next(target)
        } else if (hasToken) {
            next('/homeDetail')
        } else {
            nProgress.start()
            next()
        }
        return
    }

    // 其他页面：必须有 token，否则回登录页
    if (hasToken) {
        nProgress.start()
        next()
    } else {
        nProgress.done()
        next('/login')
    }
});

router.afterEach(() => {
    nProgress.done();
});


export default router;
